import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  fullCommission: "/reports/full-commission",

  paymentsHistory: "/commissions/payments-history",

  normalCommission: "/commissions/payout/preview",
  normalCommissionSettlement: "/commissions/settlement",

  subscriptionCommission: "/reports/subscription-commissions",
  subscriptionCommissionSettlement: "/subscriptions/settlement",
};

export const fetchFullCommission = createAsyncThunk(
  "full-commission/fetchFullCommission",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.fullCommission, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Tipagem explícita para backend
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);

export const fetchPaymentsHistoryCommmission = createAsyncThunk(
  "full-commission/fetchPaymentsHistoryCommmission",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.paymentsHistory, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Tipagem explícita para backend
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);

export const fetchNormalCommmission = createAsyncThunk(
  "full-commission/fetchNormalCommmission",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.normalCommission, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Tipagem explícita para backend
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);

export const fetchsubscriptionCommission = createAsyncThunk(
  "full-commission/fetchsubscriptionCommission",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        endpoint.subscriptionCommission,
        { params },
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        // Tipagem explícita para backend
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };

        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }

      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);

export const normalCommissionSettlement = createAsyncThunk(
  "full-commission/normalCommissionSettlement",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.normalCommissionSettlement,
        data,
        { params: { auto_create: true } },
      );
      return response.data;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        const backend = error.response?.data;
        const backendMessage =
          backend &&
          typeof backend === "object" &&
          "message" in backend &&
          typeof backend.message === "string"
            ? backend.message
            : error.message;
        return thunkAPI.rejectWithValue({ error: backendMessage });
      } else if (error instanceof Error) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const subscriptionCommissionSettlement = createAsyncThunk(
  "full-commission/subscriptionCommissionSettlement",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.subscriptionCommissionSettlement,
        data,
      );
      return response.data;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        const backend = error.response?.data;
        const backendMessage =
          backend &&
          typeof backend === "object" &&
          "message" in backend &&
          typeof backend.message === "string"
            ? backend.message
            : error.message;
        return thunkAPI.rejectWithValue({ error: backendMessage });
      } else if (error instanceof Error) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
